import { DateRange } from '@shared/models/common.models';
import { MonitoringReportResponseDTO } from '@generated-apis/model/monitoringReportResponseDTO';
import { PersistedReportRequest } from '@shared/services/report-stream/report-stream.models';

export class StartReportGeneration {
  static readonly type = '[ReportGeneration] Start report generation';

  constructor(
    public geaPUID: string,
    public dateRange: DateRange
  ) {}
}

export class ResumeReportGeneration {
  static readonly type = '[ReportGeneration] Resume report generation';

  constructor(public request: PersistedReportRequest) {}
}

export class DownloadGeneratedReport {
  static readonly type = '[ReportGeneration] Download generated report';

  constructor(public downloadPath: string) {}
}

export class ResetReportGeneration {
  static readonly type = '[ReportGeneration] Reset report generation';
}

export class MonitoringReportDataLoaded {
  static readonly type = '[ReportGeneration] Report General Data Loaded';

  constructor(public report: MonitoringReportResponseDTO) {}
}
